module.exports = __webpack_public_path__ + "components/smartbar/static/smartbanner-icon-09bf3471fd19be042f8ac01d9cadb461.png";